/**
 * @module store/tax/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetKindchallengeTaxRate, apiSetKindchallengeTaxRate } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Get kindchallenge tax settings
 *
 * @since Version 1.0.0
 */
const getKindchallengeTaxRate = async ({ commit, rootGetters }) => {
  commit(types.GET_TAX_KINDCHALLENGE_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data } = await apiGetKindchallengeTaxRate(userSession.accessToken.jwtToken);

      commit(types.GET_TAX_KINDCHALLENGE_ASYNC.SUCCESS, {
        data,
      });
    } else {
      throw new Error('Неавторизований користувач не може отримати список e-mail.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_TAX_KINDCHALLENGE_ASYNC.FAILURE);
  }
};

/**
 * Action: Set kindchallenge tax settings
 *
 * @since Version 1.0.0
 */
const setKindchallengeTaxRate = async ({ commit, dispatch, rootGetters }, taxSettings) => {
  commit(types.GET_TAX_KINDCHALLENGE_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetKindchallengeTaxRate(userSession.accessToken.jwtToken, taxSettings);
      await dispatch('getKindchallengeTaxRate');
    } else {
      throw new Error('Неавторизований користувач не може змінювати налаштування.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
};

export default {
  getKindchallengeTaxRate,
  setKindchallengeTaxRate,
};
